import { createPortal } from "react-dom";
import {
  MIN_CONTENT_SCALE,
  MAX_CONTENT_SCALE,
} from "PosterEditor/utils/canvas-drawing/canvas-drawing-gallery";
import styles from "./MobileViewportOverlay.module.css";

interface MobileViewportOverlayProps {
  focusedViewportId: string;
  viewportScreenRect?: { x: number; y: number; width: number; height: number };
  hasImage: boolean;
  currentScale: number;
  onDone: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

const ZoomOutIcon = () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none">
    <circle cx="9" cy="9" r="6.5" stroke="white" strokeWidth="2" />
    <line x1="14" y1="14" x2="20" y2="20" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <line x1="5.5" y1="9" x2="12.5" y2="9" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const ZoomInIcon = () => (
  <svg width={22} height={22} viewBox="0 0 22 22" fill="none">
    <circle cx="9" cy="9" r="6.5" stroke="white" strokeWidth="2" />
    <line x1="14" y1="14" x2="20" y2="20" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <line x1="5.5" y1="9" x2="12.5" y2="9" stroke="white" strokeWidth="2" strokeLinecap="round" />
    <line x1="9" y1="5.5" x2="9" y2="12.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const MobileViewportOverlay = ({
  hasImage,
  currentScale,
  onDone,
  onZoomIn,
  onZoomOut,
}: MobileViewportOverlayProps) => {
  const canZoomIn = hasImage && currentScale < MAX_CONTENT_SCALE;
  const canZoomOut = hasImage && currentScale > MIN_CONTENT_SCALE;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleButtonClick = (e: React.MouseEvent, onClick: () => void) => {
    e.stopPropagation();
    e.preventDefault();
    onClick();
  };

  return createPortal(
    <div className={styles.toolbar} onClick={handleClick}>
      {hasImage && (
        <div className={styles.zoomGroup}>
          <button
            className={styles.zoomButton}
            onClick={(e) => handleButtonClick(e, onZoomOut)}
            onMouseDown={handleClick}
            disabled={!canZoomOut}
            aria-label="Zoom out"
          >
            <ZoomOutIcon />
          </button>
          <button
            className={styles.zoomButton}
            onClick={(e) => handleButtonClick(e, onZoomIn)}
            onMouseDown={handleClick}
            disabled={!canZoomIn}
            aria-label="Zoom in"
          >
            <ZoomInIcon />
          </button>
        </div>
      )}
      {!hasImage && <div />}
      <button
        className={styles.doneButton}
        onClick={(e) => handleButtonClick(e, onDone)}
        onMouseDown={handleClick}
      >
        Done
      </button>
    </div>,
    document.body
  );
};
